import { render, staticRenderFns } from "./DiscountNote.vue?vue&type=template&id=55a5bc4a&scoped=true"
import script from "./DiscountNote.vue?vue&type=script&lang=js"
export * from "./DiscountNote.vue?vue&type=script&lang=js"
import style0 from "./DiscountNote.vue?vue&type=style&index=0&id=55a5bc4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a5bc4a",
  null
  
)

export default component.exports